import SettingsEthernetOutlinedIcon from "@mui/icons-material/SettingsEthernetOutlined";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import type { GridColDef, GridColumnMenuItemProps } from "@mui/x-data-grid-premium";

interface Props extends GridColumnMenuItemProps {
  onSetWidth: (column: GridColDef) => void;
}

const ColumnMenuWidthItem = ({ colDef, onClick, onSetWidth }: Props) => (
  <MenuItem
    disabled={colDef.resizable === false}
    onClick={(event) => {
      onClick?.(event);
      onSetWidth(colDef);
    }}
  >
    <ListItemIcon>
      <SettingsEthernetOutlinedIcon />
    </ListItemIcon>
    <ListItemText>Set width</ListItemText>
  </MenuItem>
);

export default ColumnMenuWidthItem;
